import { render, staticRenderFns } from "./pingus.vue?vue&type=template&id=4c0bb12a&scoped=true"
import script from "./pingus.vue?vue&type=script&lang=js"
export * from "./pingus.vue?vue&type=script&lang=js"
import style0 from "./pingus.vue?vue&type=style&index=0&id=4c0bb12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bb12a",
  null
  
)

export default component.exports